export const nl = {
    money: {
        style: 'currency',
        currency: 'EUR',
    },
    whole: {
        style: 'number',
        maximumFractionDigits: 0,
    },
    percentage: {
        style: 'percent',
        maximumFractionDigits: 0,
    },
};

export const numberFormats = {
    nl,
};



// WEBPACK FOOTER //
// ./src/languages/numbers.js